import Reveal from "../components/Reveal";

export default function ShowcaseBand() {
  return (
    <section className="relative overflow-hidden" data-testid="showcase-band">
      <div
        className="absolute inset-0 bg-cover bg-center lg:bg-fixed"
        style={{ backgroundImage: "url(/img/sparks.jpg)" }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-[#080C14]/85" />
      <div className="relative mx-auto max-w-5xl px-5 sm:px-8 py-24 lg:py-36 text-center">
        <Reveal>
          <p className="eyebrow flex items-center justify-center gap-3">
            <span className="inline-block h-px w-10 bg-amber-400/70" />
            Our Promise
            <span className="inline-block h-px w-10 bg-amber-400/70" />
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold uppercase leading-tight text-stone-50 [text-shadow:0_4px_28px_rgba(8,12,20,0.9)]">
            Consistent quality. <span className="text-molten">Dimensional accuracy.</span>{" "}
            Reliable delivery.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-7 max-w-2xl text-sm sm:text-base leading-relaxed text-stone-300">
            Every component is inspected for dimensional accuracy, appearance and other specified
            requirements before dispatch — from 50 g to 800 g, from a single development die to
            regular production runs.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
